import { useNavigate } from 'react-router';

import TitleAndImageWrapper from '@/shared/components/layout/TitleAndImageLayout';
import { routes } from '../../constants/Constants';

type ErrorPageProps = {
  title?: string;
  subtitle?: string;
  onBack?: () => void;
};

const ErrorPage = ({
  title = '404 Error',
  subtitle = 'Something went wrong. The page you are looking for could not be found.',
  onBack,
}: ErrorPageProps) => {
  const navigate = useNavigate();

  return (
    <TitleAndImageWrapper
      name="Error"
      title={title}
      subtitle={subtitle}
      clickFuntion={() => (onBack ? onBack() : navigate(routes.propertyEnrollmentForm))}
      buttonName="Back to Homepage"
    />
  );
};

export default ErrorPage;
